import UploadPhotosComponent from "./uploadPhotosComponent";

export default UploadPhotosComponent



// WEBPACK FOOTER //
// ./src/components/uploadPhotosComponent/index.ts